import cls from "./AboutPage.module.scss";
import {classNames} from "shared/lib/classNames/classNames";
import Title, {TitleTheme} from "shared/ui/Title/Title";
import Paragraph from "shared/ui/Paragraph/Paragraph";
import About1 from "shared/assets/images/about1.png";
import About2 from "shared/assets/images/about2.png";

export const AboutPage = () => {
    return (
        <div id={"aboutPage"} className={"aboutPage"}>
            <section className={classNames("page-section", {}, [cls.aboutPage__about])}>
                <div className={classNames("container container__main")}>
                    <div className={cls.about}>
                        <Title className={cls.about__title} sentences={["About Us"]} colors={[TitleTheme.NEUTRAL]} />
                        <Paragraph>
                            Our enthusiastic group of app creators, UI/UX experts, and planners is committed to developing mobile software that engages and impresses its audience. Having navigated the constantly shifting mobile tech terrain for numerous years, we've refined our expertise to provide outcomes that surpass our clients' anticipations.
                        </Paragraph>

                        <div className={cls.segmented}>
                            <div className={cls.segmented__item}>
                                <img src={About1} alt="table"/>
                            </div>

                            <div className={cls.segmented__item}>
                                <img src={About2} alt="building"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
